export const SET_LOCATABLE = "SET_LOCATABLE";

export const REMOVE_LOCATABLE = "REMOVE_LOCATABLE";


// WEBPACK FOOTER //
// ./src/constants/location.js